import React from 'react';

export const CommonModelImpl = ({ msg, okButtonShow, okButtonText, okAction,
  cancelButtonShow, cancelButtonText, cancelAction, }) => {

  //Model shows the limit exceed the limit
  return (
    <div className="hoverlay">
      <div className="popup_inner">
      <div className="close_popup">
        <button onClick= {cancelAction}>X</button>
      </div>
      <div className="popup_content">
      <div className="popup_txt">
          <p>{msg}</p>
        </div>
        <div className="popup_footer">
          {cancelButtonShow &&
            <button onClick= {cancelAction}>{cancelButtonText}</button>
          }
          {okButtonShow &&
            <button onClick= {okAction}>{okButtonText}</button>
          }
        </div>
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./web/components/common/CommonModel.jsx